
import { Plus, MessageSquare } from "lucide-react";

interface EnquiryHeaderProps {
  onAddClick: () => void;
}

export default function EnquiryHeader({ onAddClick }: EnquiryHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center">
          <MessageSquare className="w-6 h-6 text-blue-600" />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-stone-900">Enquiries</h1>
          <p className="text-sm text-stone-500 mt-1">Manage incoming enquiries and convert to quotations</p>
        </div>
      </div>
      <button
        onClick={onAddClick}
        className="px-5 py-2.5 rounded-xl text-white font-semibold text-sm bg-amber-500 hover:bg-amber-600 transition-colors flex items-center justify-center gap-2 self-start sm:self-auto shadow-sm hover:shadow-md"
      >
        <Plus className="w-4 h-4" />
        Add Enquiry
      </button>
    </div>
  );
}
